import React from "react";

// external package
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowTrendUp } from "@fortawesome/free-solid-svg-icons";

// i18n & source
import { useTranslation } from "../../i18n";
import { historyJobSource, formatJobDate } from "../../source/historyJobSource";

export default function CurrentPositionComponent() {
  const { t, lang } = useTranslation();
  const current = historyJobSource[0];
  return (
    <div className="current_position">
      <div className="title font-size-30 font-vietnam-600 d-flex justify-content-between align-items-center">
        <span> {t.about.currentPosition}</span>
        <a
          href="/history-job"
          rel="noreferrer"
          className="font-size-28 font-vietnam-300 font-black-1"
        >
          <FontAwesomeIcon icon={faArrowTrendUp} />
        </a>
      </div>
      <div className="content mt-2">
        <div className="title">
          <span className="font-size-18 font-vietnam-600">
            {current.company}
          </span>
          <span className="ms-2 font-size-14 font-vietnam-300-italic">
            {formatJobDate(current.startDate, lang)} -{" "}
            {current.endDate
              ? formatJobDate(current.endDate, lang)
              : t.history.present}
          </span>
          <div className="font-size-12 font-vietnam-300">
            {current.location} ({t.history.workType[current.workType]})
          </div>
        </div>
        <div className="position font-size-14 font-vietnam-300">
          {current.position}
        </div>
      </div>
    </div>
  );
}
